import { Group, HoverCard, Text, ThemeIcon } from "@mantine/core"
import { IconInfoOctagon } from "@tabler/icons-react"

interface Props {
  anchorText: string
  description?: React.ReactNode
}

export function DescriptionHoverCard({ anchorText, description }: Props) {
  return (
    <HoverCard width="15rem" shadow="md">
      <HoverCard.Target>
        <div style={{ cursor: "help", width: "fit-content" }}>
          <Group gap="0.25rem">
            <ThemeIcon
              color="transparent"
              c="var(--mantine-primary-color-filled)"
              size="xs"
            >
              <IconInfoOctagon size="1rem" />
            </ThemeIcon>
            <Text
              component="span"
              size="xs"
              c="var(--mantine-primary-color-filled)"
            >
              {anchorText}
            </Text>
          </Group>
        </div>
      </HoverCard.Target>
      <HoverCard.Dropdown>{description}</HoverCard.Dropdown>
    </HoverCard>
  )
}
